/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, useState, useMemo } from 'react';
import { TypedUseSelectorHook, useSelector, useDispatch } from 'react-redux';
import NavigationArrow from './NavigationArrow';
import {
  setTempLocation,
  setTempTags,
} from '../../../../Slice/impactReportSlice';
import type { RootState } from '../../../../../../store/store';
import s from './style/saved.module.scss';

const FilterItem = React.lazy(() => import('../FilterItem'));

interface ISavedData {
  description: string;
  name: string;
  id: number;
  locationType: number;
  items: Array<{ value: string; entityId: string }>;
}

type RecentSectionProps = {
  handleConfirm: () => void;
  data: Array<ISavedData>;
};

const SavedSection: FC<RecentSectionProps> = ({ handleConfirm, data }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
  const dispatch = useDispatch();

  const items = useAppSelector((state) => state.impactReport);

  const filterData = useMemo(() => {
    if (!data) return [];

    return data.map((item) => ({
      name: item.name,
      description: item.description,
      title:
        (
          items.allFilters?.find(
            (filter: any) => filter.locationType === item.locationType
          ) as any
        )?.value || 'Unknown',
      locationType: item.locationType,
      items: item.items?.map((v) => v.value),
      item: item.items,
      id: item.id,
    }));
  }, [data, items.allFilters]);

  // Enhanced filter logic to match all words in the search query with partial matching

  // Example usage in your component logic
  const filteredData = useMemo(() => {
    const searchWords = searchQuery.toLowerCase().split(' ').filter(Boolean);

    if (searchWords.length === 0) return filterData;

    const searchResults = search(
      searchQuery,
      filterData.map((item) => item.name)
    );

    return filterData.filter((filter) => searchResults.includes(filter.name));
  }, [searchQuery, filterData]);

  // Pagination logic
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Determine the behavior for the filter items based on their position
  const totalItems = paginatedData.length;

  // eslint-disable-next-line consistent-return
  const determineRenderContext = (index: number) => {
    if (index < 3) {
      // First three items: show below the kebab icon
      return false;
    }
    if (index >= totalItems - 3) {
      // Last three items: show above the kebab icon
      return true;
    }
  };

  return (
    <>
      <div className={s.list}>
        {data.length === 0 ? (
          <div className={`${s.item} ${s.emptyPage}`}>
            You haven’t saved any filters yet!
            <br /> Save your favorite filters to find what you need faster.
          </div>
        ) : (
          <>
            <div className={s.item} style={{ justifyContent: 'flex-start' }}>
              Filter name
            </div>
            <div className={s.search}>
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_2714_3146)">
                  <circle
                    cx="8.625"
                    cy="8.625"
                    r="7.125"
                    stroke="#7A89A7"
                    strokeWidth="1.5"
                  />
                  <path
                    d="M13.875 13.875L16.5 16.5"
                    stroke="#7A89A7"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2714_3146">
                    <rect width="18" height="18" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <input
                type="text"
                placeholder="Search"
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setCurrentPage(1);
                }}
                className={s.searchInput}
              />
              {searchQuery.length >= 1 && (
                <button
                  type="button"
                  onClick={() => {
                    setSearchQuery('');
                    setCurrentPage(1);
                  }}
                  className={s.clear}
                >
                  <svg
                    viewBox="0 0 10 10"
                    width="0.75em"
                    height="0.75em"
                    stroke="#7A89A7"
                    strokeWidth="2"
                  >
                    <line x1="1" y1="1" x2="9" y2="9" />
                    <line x1="9" y1="1" x2="1" y2="9" />
                  </svg>
                </button>
              )}
            </div>
            {filteredData.length === 0 ? (
              <div>
                <div className={s.empty}>
                  For your search query, no results were found.
                </div>
              </div>
            ) : (
              <>
                <div>
                  <div className={s.paginatedData}>
                    {paginatedData.map((filter, index) => (
                      <>
                        <FilterItem
                          total={data.length}
                          key={filter.id}
                          title={filter.title}
                          id={filter.id}
                          actionButton
                          deleteFunc={() => {
                            setCurrentPage(1);
                          }}
                          name={filter.name}
                          comments={filter.description}
                          items={filter.items}
                          locationIds={filter.item}
                          locationType={filter.locationType}
                          renderContextOnTop={determineRenderContext(index)}
                          handleApply={() => {
                            dispatch(
                              setTempLocation({
                                value: filter.title,
                                locationType: filter.locationType,
                              })
                            );
                            dispatch(setTempTags(filter.item));
                            handleConfirm();
                          }}
                        />
                      </>
                    ))}
                  </div>
                  {filteredData.length >= 10 && (
                    <div className={s.pagination}>
                      <button
                        type="button"
                        className={`${
                          currentPage === 1
                            ? s.pagination__disable
                            : s.pagination__arrow
                        } ${s.pagination__arrow__left}`}
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                      >
                        <NavigationArrow
                          position="left"
                          isDisable={currentPage === 1}
                        />
                      </button>
                      <span className={s.pagination__total}>
                        Page {currentPage} of {totalPages}
                      </span>

                      <button
                        type="button"
                        className={`${
                          currentPage === totalPages
                            ? s.pagination__disable
                            : s.pagination__arrow
                        } ${s.pagination__arrow__right}`}
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(prev + 1, totalPages)
                          )
                        }
                      >
                        <NavigationArrow
                          position="right"
                          isDisable={currentPage === totalPages}
                        />
                      </button>
                    </div>
                  )}
                </div>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default SavedSection;

function search(query: string, data: string[]): string[] | string {
  try {
    if (!query || typeof query !== 'string' || !Array.isArray(data)) {
      throw new Error(
        'Invalid input: query must be a string and data must be an array of strings.'
      );
    }

    // Trim the query and normalize it for better matching
    const normalizedQuery = query.trim().toLowerCase();

    if (normalizedQuery === '') return 'No query provided.';
    // Perform the search with partial matching using array filter and includes
    const results = data.filter((item) =>
      item.toLowerCase().includes(normalizedQuery)
    );
    // Return the results or a message if no match is found
    return results.length > 0 ? results : 'No matches found.';
  } catch (error) {
    console.error('An error occurred during the search operation:', error);
    return 'An error occurred during the search operation.';
  }
}
